import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import Config from '../../Core/Config.js';
import { framework } from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import { libs, ui } from 'saffroncodejs';
var PageManager = framework.PageManager;

class Hamlonaghl extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isLoading: true,
            activeTab: 1,
            data: { "CodeMelli": "2142596347", "BId": 1358323, "FullBNo": "96/04/700/8055/4001559", "SodurDate": "1396/02/30", "LastBNo": null, "AgentText": "شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055", "BimeGozarText": "علي ولائي کد 2599583 به نفع بانک صنعت و معدن  شعبه ساري", "CodMelliOrEconomic": "2142596347", "BimegozarAddress": "استان ‏مازندران‏،شهر آمل-شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي", "BimegozarTel": "01222523538", "BimeKindText": "صنعتي", "ActivityKindText": "‏چراغ روشنايى خيابان ـ توليد‏", "ActivitySharh": "توليد چراغ روشنايي گاز", "AddressText": "استان ‏مازندران‏،شهر آمل ، شهرک صنعتي امامزاده عبداله- فاز1- کارگاه توليدي آقاي ولايي", "Moddat": 365, "BeginDate": "1396/03/01", "EndDate": "1397/03/01", "AllRiskText": " آتش سوزي ، صاعقه ، انفجار ، زلزله و آتشفشان ، سيل و طغيان آب ، طوفان و گردباد و تندباد ، ضايعات ذوب برف و آب باران ، ريزش سقف ناشي ازسنگيني برف ، تركيدگي لوله آب ، انفجار ظروف تحت فشار صنعتي ، دفرمه شدن ظروف تحت فشار", "MarhunatSarmaye": 1024000000, "MarhunatHbStr": "883,650 ريال", "HBStr": "883,650 ريال", "SumSarmayeStr": "1,024,000,000 ريال", "SAAMPercent": "%9", "MaliatAvarez": "79,529 ريال", "HBWithAvarezStr": "963,179 ريال", "Reshte": 1, "Endorsement": [], "Mavared": [{ "ShahrdariAvarezNerkh": 3, "AfzoodeMaliatNerkh": 6, "BId": 1358323, "ElhNo": 0, "GId": 349, "MoredeBimeText": null, "MavaredTitr": "عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :", "BNo": "96/04/700/8055/4001559", "SodurText": "شعبه ساري کد 700", "AgentText": "شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055", "LastBNo": null, "PishnahadDate": "1396/02/16", "SodurDate": "1396/02/30", "SumSarmaye": 1024000000, "SumSarmayeStr": "يك ميليارد و بيست و چهار ميليون", "HB": 883650, "HBText": "هشتصد و هشتاد و سه هزار و ششصد و پنجاه", "MoneyUnitText": "ريال", "Sharh": "ساختمان توليد ، اداري  با مساحت تقريبي 366  مترمربع  به  انضمام کليه تاسيسات مربوطه جمعا\" به ارزش", "Sarmaye": "253,000,000", "MaxCommitment": "253,000,000", "Nerkh": "0.75", "MHB": "126,500", "Radif": "1", "InnerOrder": 1 }, { "ShahrdariAvarezNerkh": 3, "AfzoodeMaliatNerkh": 6, "BId": 1358323, "ElhNo": 0, "GId": 349, "MoredeBimeText": null, "MavaredTitr": "عبارت است از اموال متعلق به بيمه گذار و مورد تاييد کارشناس محترم بانک صنعت و معدن طبق نامه شماره 2148/م/الف مورخ 1396/02/26مادامي که در نشاني مورد بيمه نگهداري و يا مورد استفاده قرار گيرد به شرح ذيل :", "BNo": "96/04/700/8055/4001559", "SodurText": "شعبه ساري کد 700", "AgentText": "شرکت کارگزاري توسعه صنعت و معدن نوانديشان 503 کد 8055", "LastBNo": null, "PishnahadDate": "1396/02/16", "SodurDate": "1396/02/30", "SumSarmaye": 1024000000, "SumSarmayeStr": "يك ميليارد و بيست و چهار ميليون", "HB": 883650, "HBText": "هشتصد و هشتاد و سه هزار و ششصد و پنجاه", "MoneyUnitText": "ريال", "Sharh": "ماشين آلات  و تجهيزات طبق ليست پيوست نامه شماره 2148/م/الف بانک صنعت و معدن ساري جمعا\" به ارزش", "Sarmaye": "771,000,000", "MaxCommitment": "771,000,000", "Nerkh": "0.9", "MHB": "385,500", "Radif": "2", "InnerOrder": 1 }], "Bill": [], "PishnahadNo": null, "PishnahadDate": "1396/02/16", "ElhNo": 0, "ErrorMessage": null }
        }
        this.state.data = {};

        this.state.btns = [];

        this.loadDetail();

    }

    encodeSodurId(encodedId) {
        return encodedId;
    }

    componentWillReceiveProps(props) {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail() {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Ms/api/MsMHN/PolicyInfo",

                { id: this.currentSodurId, codeMelli: UserManager.MelliCode() }
            ),
            BimeManager.header())
            .then((result) => {
                this.setState({ data: result.data, isLoading: false })
                
            })
            .catch((error) => { alert(error) })
    }
    pagechange(bid,reshte) {
        
        PageManager.changePage(Config.p_pardakhtman,[bid,reshte]);
    }

    render() {
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>حمل و نقل</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({ activeTab: 1 }) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({ activeTab: 2 }) }}>
                            الحاقیه
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 3 }}
                            onClick={() => { this.setState({ activeTab: 3 }) }}>
                            طبقه بندی
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink onClick={() => {this.pagechange(this.currentSodurId,this.state.data.Reshte)}}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 4 }}
                            onClick={() => { this.setState({ activeTab: 4 }) }}>
                            بارنامه
                        </NavLink>
                    </NavItem>
                    
                </Nav>


                    {(!this.state.isLoading) ? (


                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId={1}>
                                <Row>
                                    <Col sm="12">
                                        <div className="container ListOfList">
                                            <Row>
                                                <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{this.state.data.BId}</Col>
                                                <Col sm="12"><span className="bold-head">نماينده / کارگزار:</span>{this.state.data.AgentCodeText}</Col>
                                                <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.FullBNo}</Col>
                                                <Col sm="12"><span className="bold-head">شماره بیمه نامه قبلی:</span>{this.state.data.LastBNO}</Col>
                                                <Col sm="12"><span className="bold-head">واحد صدور:</span>{this.state.data.CodeSodurText}</Col>
                                                <Col sm="12"><span className="bold-head">تاريخ صدور:</span>{this.state.data.BNSodurDate}</Col>
                                                <Col sm="12"><span className="bold-head">شماره پیشنهاد:</span>{this.state.data.PishnahadNo}</Col>
                                                <Col sm="12"><span className="bold-head">تاريخ پيشنهاد:</span>{this.state.data.PishnahadDate}</Col>
                                                <Col sm="12"><span className="bold-head">بيمه گذار:</span>{this.state.data.BimeGozarPrintName}</Col>
                                                <Col sm="12"><span className="bold-head">نشانی بیمه گذار:</span>{this.state.data.BGAddress}</Col>
                                                <Col sm="12"><span className="bold-head">تلفن / فکس:</span>{this.state.data.BGTel}</Col>
                                                <Col sm="12"><span className="bold-head">شماره توافقنامه:</span>{this.state.data.FullGId}</Col>
                                                <Col sm="12"><span className="bold-head">کد ملی:</span>{this.state.data.CodeMelli}</Col>
                                                <Col sm="12"><span className="bold-head">نوع بيمه گذار:</span>{this.state.data.CustomerKindText}</Col>
                                                <Col sm="12"><span className="bold-head">کد پستی:</span>{this.state.data.BGCodePosti}</Col>
                                                <Col sm="12"><span className="bold-head">مدت بیمه:</span>{this.state.data.Moddat}</Col>
                                                <Col sm="12"><span className="bold-head">تاریخ شروع:</span>{this.state.data.beginDate}</Col>
                                                <Col sm="12"><span className="bold-head">تاریخ پایان:</span>{this.state.data.EndDate}</Col>
                                                <Col sm="12"><span className="bold-head">حداقل حق بيمه هر مورد</span>{libs.StringFunctions.currancyPrint(this.state.data.HBMinimum)+('ریال')}</Col>
                                                <Col sm="12"><span className="bold-head">مبلغ سپرده:</span>{libs.StringFunctions.currancyPrint(this.state.data.Seporde)+('ریال')}</Col>
                                                <Col sm="12"><span className="bold-head">پوششهای الحاقی:</span>{this.state.data.Ezafi}</Col>
                                                <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(this.state.data.AfzoodehMaliat)+('ریال')}</Col>
                                                <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(this.state.data.ShahrdariAvarez)+('ریال')}</Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>

                            <TabPane tabId={2}>
                                <Row>
                                    <Col sm="12">
                                        <div className="container ListOfList">
                                            <Row>
                                                {
                                                    //alert('bill***'+this.state.data.Bill)
                                                    (this.state.data.Endorsement) ? this.state.data.Endorsement.map((endorsement) => {
                                                        return <div className="border-List">
                                                            <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{endorsement.NoeBimename}</Col>
                                                            <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{endorsement.BId}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{endorsement.FullBNO}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{endorsement.ElhNo}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره ردیف سالانه:</span>{endorsement.Radif}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{endorsement.ElhSodurDate}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ اعمال:</span>{endorsement.ElhActiveDate}</Col>
                                                            <Col sm="12"><span className="bold-head">ساعت صدور:</span>{endorsement.SodurTime}</Col>
                                                            <Col sm="12"><span className="bold-head">معرف/کارگزار:</span>{endorsement.AgentCodeText}</Col>
                                                            <Col sm="12"><span className="bold-head">بیمه گذار:</span>{endorsement.BimeGozarText}</Col>
                                                            <Col sm="12"><span className="bold-head">واحد صدور:</span>{endorsement.CodeSodurText}</Col>
                                                            <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{endorsement.Sharh}</Col>
                                                            <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(endorsement.ShahrdariAvarez)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(endorsement.AfzoodehMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiPrm)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiPrm)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiPrmWithMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiPrmWithMaliat)+('ریال')}</Col>
                                                            <br />
                                                            </div>

                                                    }) : ''
                                                }

                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>

                            <TabPane tabId={3}>
                                <Row>
                                    <Col sm="12">
                                        <div className="container ListOfList">
                                            <Row>
                                                {
                                                    //alert('bill***'+this.state.data.Bill)
                                                    (this.state.data.RateClassification) ? this.state.data.RateClassification.map((tabaghebandi) => {
                                                        return <div className="border-List">
                                                            <Col sm="12"><span className="bold-head">نوع طبقه بندی:</span>{tabaghebandi.TabagheText}</Col>
                                                            <Col sm="12"><span className="bold-head">از:</span>{libs.StringFunctions.currancyPrint(tabaghebandi.FromVal)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">تا:</span>{libs.StringFunctions.currancyPrint(tabaghebandi.ToVal)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">نرخ (هزار):</span>{tabaghebandi.NerkhText}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه ثابت:</span>{tabaghebandi.ConstHB}</Col>
                                                            <br />
                                                            </div>

                                                    }) : ''
                                                }

                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>


                            <TabPane tabId={4}>
                                <Row>
                                    <Col sm="12">
                                        <div className="container ListOfList">
                                            <Row>
                                                {
                                                    //alert('bill***'+this.state.data.Bill)
                                                    (this.state.data.BillOfLading) ? this.state.data.BillOfLading.map((barname) => {
                                                        return <div className="border-List">
                                                            <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{barname.ElhNo}</Col>
                                                            <Col sm="12"><span className="bold-head">از شماره بارنامه:</span>{barname.FromVal}</Col>
                                                            <Col sm="12"><span className="bold-head">تاشماره بارنامه:</span>{barname.ToVal}</Col>
                                                            <Col sm="12"><span className="bold-head">سری بارنامه:</span>{barname.Seri}</Col>
                                                            <br />
                                                            </div>

                                                    }) : ''
                                                }

                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>

                        </TabContent>) : (<ui.Preloader />)



                    }
         </div>
                );
            }
        }
        
        
export default Hamlonaghl;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/Hamlonaghl.js